import { defineComponent as P, ref as S, computed as x, onMounted as E, openBlock as a, createElementBlock as o, createElementVNode as c, renderSlot as d, createVNode as m, withCtx as k, normalizeProps as w, guardReactiveProps as g, normalizeStyle as z, createBlock as $, Fragment as u, renderList as b } from "vue";
import R from "./index62.js";
import F from "./index55.js";
import M from "./index56.js";
const N = {
  class: "table-wrapper",
  "data-name": "Table"
}, V = { class: "table-header-fixed" }, A = { class: "table-container" }, I = { class: "table" }, j = { class: "table-container" }, q = { class: "table" }, D = {
  key: 1,
  class: "table-skeleton"
}, G = {
  key: 1,
  class: "table-container"
}, J = { class: "table" }, K = {
  key: 1,
  class: "table-skeleton"
}, X = /* @__PURE__ */ P({
  __name: "BaseTable",
  props: {
    headers: {},
    data: {},
    selectable: { type: Boolean, default: !1 },
    sortable: { type: Boolean, default: !1 },
    selectedRows: { default: () => [] },
    headerType: { default: "type1" },
    headerPreset: { default: "gray" },
    headerCustomColor: {},
    isLoading: { type: Boolean, default: !1 },
    skeletonRows: { default: 5 },
    maxHeight: {},
    hasMore: { type: Boolean, default: !1 },
    isLoadingMore: { type: Boolean, default: !1 },
    infiniteScrollThreshold: { default: 100 }
  },
  emits: ["rowSelect", "sort", "loadMore"],
  setup(e, { emit: T }) {
    const t = e, i = T, f = S(null), y = S(!1), h = x(() => t.maxHeight !== void 0), B = async (s) => {
      if (!h.value) return;
      const r = s.target;
      if (!r || !t.hasMore || t.isLoadingMore || t.isLoading) return;
      const l = r.scrollTop, n = r.scrollHeight, L = r.clientHeight;
      n - l - L < t.infiniteScrollThreshold && i("loadMore");
    }, C = async () => {
      if (!(!h.value || !f.value || y.value || t.isLoadingMore || t.isLoading || !t.hasMore)) {
        y.value = !0;
        try {
          for (; ; ) {
            const { scrollHeight: s, clientHeight: r } = f.value;
            if (s > r || !t.hasMore)
              break;
            i("loadMore"), await new Promise((l) => setTimeout(l, 50));
          }
        } finally {
          y.value = !1;
        }
      }
    };
    E(() => {
      h.value && t.data.length > 0 && setTimeout(() => {
        C();
      }, 100);
    });
    const v = (s, r) => {
      i("rowSelect", s, r);
    }, H = (s) => {
      t.sortable && i("sort", s, "asc");
    };
    return (s, r) => (a(), o("div", N, [
      c("div", V, [
        c("div", A, [
          c("table", I, [
            d(s.$slots, "head", {}, () => [
              m(F, {
                headers: e.headers,
                type: e.headerType,
                preset: e.headerPreset,
                "custom-color": e.headerCustomColor,
                onSort: H
              }, {
                "head-cell": k((l) => [
                  d(s.$slots, "head-cell", w(g(l)))
                ]),
                _: 3
              }, 8, ["headers", "type", "preset", "custom-color"])
            ])
          ])
        ])
      ]),
      h.value ? (a(), o("div", {
        key: 0,
        ref_key: "scrollContainerRef",
        ref: f,
        class: "table-body-scrollable",
        style: z({ maxHeight: t.maxHeight }),
        onScroll: B,
        "data-name": "Table/BodyScrollContainer"
      }, [
        c("div", j, [
          c("table", q, [
            d(s.$slots, "body", {}, () => [
              t.isLoading ? (a(), o("tbody", D, [
                (a(!0), o(u, null, b(t.skeletonRows, (l) => (a(), o("tr", {
                  key: `skeleton-row-${l}`,
                  class: "table-row"
                }, [
                  (a(!0), o(u, null, b(e.headers, (n) => (a(), o("td", {
                    key: `skeleton-cell-${n.key}-${l}`,
                    class: "table-cell"
                  }, [
                    m(R, {
                      width: n.key === e.headers[0].key ? "80%" : "60%",
                      height: "1rem",
                      variant: "text",
                      class: "table-skeleton-cell"
                    }, null, 8, ["width"])
                  ]))), 128))
                ]))), 128))
              ])) : (a(), $(M, {
                key: 0,
                headers: e.headers,
                data: e.data,
                selectable: e.selectable,
                "selected-rows": e.selectedRows,
                onRowSelect: v
              }, {
                "body-cell": k((l) => [
                  d(s.$slots, "body-cell", w(g(l)))
                ]),
                _: 3
              }, 8, ["headers", "data", "selectable", "selected-rows"]))
            ])
          ])
        ])
      ], 36)) : (a(), o("div", G, [
        c("table", J, [
          d(s.$slots, "body", {}, () => [
            t.isLoading ? (a(), o("tbody", K, [
              (a(!0), o(u, null, b(t.skeletonRows, (l) => (a(), o("tr", {
                key: `skeleton-row-${l}`,
                class: "table-row"
              }, [
                (a(!0), o(u, null, b(e.headers, (n) => (a(), o("td", {
                  key: `skeleton-cell-${n.key}-${l}`,
                  class: "table-cell"
                }, [
                  m(R, {
                    width: n.key === e.headers[0].key ? "80%" : "60%",
                    height: "1rem",
                    variant: "text",
                    class: "table-skeleton-cell"
                  }, null, 8, ["width"])
                ]))), 128))
              ]))), 128))
            ])) : (a(), $(M, {
              key: 0,
              headers: e.headers,
              data: e.data,
              selectable: e.selectable,
              "selected-rows": e.selectedRows,
              onRowSelect: v
            }, {
              "body-cell": k((l) => [
                d(s.$slots, "body-cell", w(g(l)))
              ]),
              _: 3
            }, 8, ["headers", "data", "selectable", "selected-rows"]))
          ])
        ])
      ]))
    ]));
  }
});
export {
  X as default
};
